import React, { useState } from 'react';
import { HiDocumentDuplicate } from "react-icons/hi2";
import MemoryModal from '../modals/MemoryModal';
import { useAuth } from '../../../auth/hooks/useAuth';

/**
 * Memory Indicator Component
 * Shows when the AI has updated saved memory (remember/forget commands)
 * Clickable to open memory management modal
 */
const MemoryIndicator = ({ message }) => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();

  if (!message?.hasMemoryUpdate) {
    return null;
  }

  // Could be used for different styling based on action type
  // const isRemember = message?.memoryAction === 'remember';
  // const isForget = message?.memoryAction === 'forget';

  const handleClick = () => {
    console.log('🧠 MemoryIndicator: Click detected, opening modal');
    console.log('🧠 MemoryIndicator: user object:', user);
    console.log('🧠 MemoryIndicator: user.userId:', user?.userId);
    console.log('🧠 MemoryIndicator: user.id:', user?.id);
    setShowModal(true);
  };

  return (
    <>
      <div className="memory-indicator-container">
        <div className="memory-indicator-header">
          <div 
            className="memory-indicator-main cursor-pointer rounded-lg transition-colors inline-flex group/memory"
            onClick={handleClick}
            title="Click to view all saved memories"
          >
            {/* Document Icon */}
            <div className="memory-icon-container">
              <HiDocumentDuplicate 
                className="w-4 h-4 text-gray-500 dark:text-[#888888] group-hover/memory:text-gray-700 dark:group-hover/memory:text-gray-400 transition-colors max-[1200px]:w-3.5 max-[1200px]:h-3.5 max-[900px]:w-3 max-[900px]:h-3 [@media(max-height:800px)]:w-3.5 [@media(max-height:800px)]:h-3.5 [@media(max-height:700px)]:w-3 [@media(max-height:700px)]:h-3" 
              />
            </div>
            
            {/* Status text */}
            <span className="memory-indicator-text text-gray-500 dark:text-[#888888] group-hover/memory:text-gray-700 dark:group-hover/memory:text-gray-400 transition-colors">
              Updated saved memory
            </span>
          </div>
        </div>
      
      {/* Memory Modal */}
      <MemoryModal 
        isOpen={showModal}
        onClose={() => {
          console.log('🧠 MemoryIndicator: Modal onClose called, setting showModal to false');
          setShowModal(false);
        }}
        userId={user?.id}
      />

      <style jsx>{`
        .memory-indicator-container {
          margin-top: 8px;
          margin-bottom: 8px;
          font-size: 13px;
          font-weight: 500;
        }

        .memory-indicator-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 1px;
          width: 100%;
        }

        .memory-indicator-main {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .memory-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .memory-indicator-text {
          font-size: 13px;
          font-weight: 500;
        }

        @media (max-width: 1200px), (max-height: 800px) {
          .memory-indicator-container {
            margin-top: 6px;
            margin-bottom: 6px;
            font-size: 12px;
          }

          .memory-indicator-text {
            font-size: 12px;
          }
        }

        @media (max-width: 900px), (max-height: 700px) {
          .memory-indicator-container {
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 11px;
          }

          .memory-indicator-text {
            font-size: 11px;
          }
        }
      `}</style>
      </div>
    </>
  );
};

export default MemoryIndicator;
